import React from "react";
import Typography from "@carrier-io/air-react/Typography";

export const TermsOfServicePage = () => {
  const currentDate = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formattedDate = `${monthNames[currentDate.getMonth()]}, ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

  return (
    <div>
      <Typography variant="h5" sx={{ marginTop: "48px", marginBottom: "16px" }}>
        Carrier Global Corporation Terms of Service Policy
      </Typography>
      <Typography variant="h6" sx={{ marginBottom: "48px" }}>
        Effective {formattedDate}
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        THESE TERMS OF USE – ACCESS (“TERMS”) GOVERN ACCESS TO AND USE OF THE
        PLATFORM (DEFINED BELOW) PROVIDED BY CARRIER BY ACCESSING OR USING THE
        PLATFORM IN ANY MANNER, THE PERSON SO ACCESSING OR USING THE PLATFORM
        AGREES TO THESE TERMS ON BEHALF OF HIS OR HER COMPANY (“COMPANY”) AND
        REPRESENTS THAT HE OR SHE HAS THE AUTHORITY TO BIND COMPANY TO THESE
        TERMS. IF THE PERSON ACCESSING OR USING THE PLATFORM DOES NOT HAVE SUCH
        AUTHORITY, OR IF COMPANY DOES NOT AGREE WITH THESE TERMS, COMPANY,
        INCLUDING THE PERSON ACCESSING OR USING THE PLATFORM, MAY NOT ACCESS OR
        USE THE PLATFORM.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        THESE TERMS MAY BE UPDATED BY CARRIER AT ANY TIME, AND FROM TIME TO
        TIME. ACCESS TO AND/OR USE OF THE PLATFORM AFTER BEING PRESENTED WITH
        THE UPDATED TERMS CONSTITUTES COMPANY’S ASSENT TO THE UPDATED TERMS.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        1. Grant of License; Restrictions.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        a. License.
        <br />
        Subject to Company’s and its Authorized User(s)’ compliance with these
        Terms, Carrier hereby grants Company a revocable, non-exclusive,
        non-transferable, non-sublicensable license to access and use the
        Platform, solely through its Authorized Users, for the purposes
        described in these Terms. Such access and use are limited to Company’s
        internal business purposes. For purposes of these Terms: (i) “Platform”
        means Carrier’s LYNX™ proprietary cloud-based, digital platform, APIs,
        and mobile and/or device applications, which, among other things,
        processes data provided by shippers, carriers, telematics providers, and
        other participants and otherwise communicate with one another and (ii)
        “Authorized Users” means Company’s and its affiliates’ employees,
        consultants, contractors, lessee, and agents who are authorized by
        Company to access and use the Platform under the rights granted to
        Company pursuant to these Terms.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        b. Reservation of Rights.
        <br />
        Except as expressly set forth in these Terms, no other rights or
        licenses, express or implied, are granted under these Terms by either
        party. No ownership of any intellectual property rights of either party
        is assigned or transferred to the other party, except as expressly
        provided herein.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        c. Restrictions.
        <br />
        All use of the Platform by Authorized Users will be considered use by
        Company and Company shall be fully liable for Authorized Users’
        compliance with these Terms. Company shall notify Carrier promptly of
        any unauthorized access or use of the Platform that violates these
        Terms. Company shall not, and shall not permit its Authorized Users to,
        directly or indirectly reverse engineer, attempt to derive the source
        code of, copy or reproduce all or any portion of the Platform, whether
        electronically, mechanically or otherwise, in any form including, but
        not limited to, copying presentation, look and feel, style, or
        organization. Company shall use, and shall cause its Authorized Users to
        use, the Platform solely for their intended purposes and shall not use,
        and shall not permit its Authorized Users to use, the Platform for the
        benefit of any third party except as specifically contemplated under
        these Terms. Without limiting the foregoing, Company hereby acknowledges
        that the Platform is intended only to allow participants within the
        logistics and transportation industry to track locations, cargo
        temperatures, Equipment and/or Hardware status, and/or otherwise
        communicate with one another and that the Platform is not intended for
        storage or use of any data not related to such purpose, including,
        without limitation, social security numbers, financial account numbers,
        health information, driver’s license, passport or visa number, credit
        card data or any special categories of personal data (“Prohibited
        Data”). Company and its Authorized Users will not input any Prohibited
        Data into the Platform. Company will not, and will not permit its
        Authorized Users to, use the Platform: (i) in violation of any
        applicable law; (ii) in a manner such that any viruses, Trojan horses,
        worms, time bombs, cancel bots, or other computer programming routines
        that are intended to damage, detrimentally interfere with,
        surreptitiously intercept or expropriate any system, data, or personal
        information are entered into the Platform; or (iii) in violation of this
        Agreement or other policy posted at the Platform website or otherwise
        made available to Company from time to time. Company shall be solely
        responsible for maintaining all passwords and access codes to the
        Platform and/or any dashboard related thereto and refraining from
        sharing or otherwise permitting third parties to use any such passwords
        and/or access codes. Any other software or services that are included in
        the Platform and are not proprietary to Carrier are licensed subject to
        the applicable license, all of which are incorporated herein by
        reference or otherwise made available to Company. Carrier shall have the
        right to immediately suspend access to the Platform if Company’s or its
        Authorized Users’ use or access of the Platform results in a risk of
        loss or damage to the Platform, Carrier’s other systems, or the data or
        property of any other Carrier licensee or supplier.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        2. Data.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        a. Data Privacy
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        Definitions: Data Privacy Laws: means applicable laws and regulations
        relating to Personal Information protection of any country, state, or
        municipality with jurisdiction to regulate the activity covered by this
        agreement. Personal Information: means information and data exchanged in
        connection with this agreement that is related to any identified or
        identifiable natural person or, to the extent of a conflict with
        applicable law, which is subject to any of the Data Privacy Laws.
        <br />
        General: Parties acknowledges that in the execution and the
        administration of the relationship between Company and Carrier, Personal
        Information of either party will be processed, in accordance with Data
        Privacy Laws. If a party provides the other party with any Personal
        Information, it will ensure that it has the legal right to do so,
        including obtaining consent and providing notice to the individuals
        whose Personal Information it has provided to the other, if needed.
        Carrier has a General Privacy Notice that covers Personal Information
        that it collects and processes for such purposes.
        <br />
        Use of the Platform: To use the Platform, the Company must successfully
        register one or more Authorized Users. To register as a user, Company
        will require that users provide certain information, including Personal
        Information. A specific Privacy Policy applies for these Authorized
        Users, and they have to consent to that specific Privacy Policy and
        these Terms of Use before being able to use the System.
        <br />
        Data breach incident: If the Personal Information is involved in a data
        breach incident, the party on whose system the data was stored is
        responsible for any notifications and associated costs. Unless
        prohibited by law or a regulator with jurisdiction over a party, the
        party making the notification shall make reasonable efforts to
        coordinate with the other party to allow for input into the content of a
        notification before it is made.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        b. Data License.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        Company hereby grants to Carrier and its Affiliates a limited,
        non-exclusive, royalty-free license to access or otherwise receive Data
        and incorporate the Data, and/or any API the Company may provide to
        Carrier to receive, copy, make available, integrate, share with Third
        Parties for the purposes of storing and/or analyzing, and otherwise use
        the Data, into the Platform for the purposes including, but not limited
        to: (a) providing Platform to You; (b) monitoring Equipment health or
        performance; (c) cargo monitoring; (d) evaluating or improving the
        Platform and/or other products and services; (e) complying with legal
        requirements and valid court orders, as applicable; (f) performing
        market research; (g) offering you new products and services; or (h) any
        other business purposes, including use with other applications (the
        “Purpose”). Data may also be gathered and transmitted to the Platform
        via other means, including but not limited to off board diagnostic
        tools. For purposes of these Terms: (i) “Data” means telematics data,
        other location data, and cargo monitoring data, other data provided by
        Company to Carrier captured by Customer’s use of the Equipment and/or
        Hardware, or data entered into the Platform by Company; (ii)
        &quot;Equipment&quot; means &quot;equipment is installed and/or other
        equipment installed on those vehicles; (iv) &quot;Hardware&quot; means
        cargo monitoring sensors and/or devices.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        c. Aggregate Data. Notwithstanding anything to the contrary, Company
        also agrees that Carrier or its affiliates may anonymize or aggregate
        the Data (such anonymized or aggregated data, “Aggregate Data”) to
        prepare reports, analyses and enhancements and to incorporate such
        Aggregate Data containing the Data into other features or work product
        in connection with the Platform and that Carrier shall own and retain
        all right, title, and interest in and to Aggregate Data. Such use shall
        survive the termination of the Terms, unless legally prohibited.
        <br />
        d. Mutual Customer. In the instance that Company and Carrier share a
        Mutual Customer that has engaged Carrier to assist it with enhancing its
        operation, the purpose of this Agreement is to allow for sharing of
        select Data through the Platform for the ultimate benefit of the Mutual
        Customer. You understand and agree that Carrier and its Affiliate may
        make the Data pertaining to a Mutual Customer available to any
        Authorized User of that Mutual Customer’s instance of the Platform, to
        any third party through the Platform to the extent requested or
        authorized by the Mutual Customer, and as otherwise authorized by
        Carrier agreement with such Mutual Customer. In addition, in order to
        receive any Data from Company’s carrier or other third party, Carrier
        may make the Data applicable to such carrier or third party available to
        such carrier or third party. For purposes of these Terms: “Mutual
        Customer” means a third party that is (a) a customer of Carrier that has
        access to the Platform and (b) a direct or indirect customer of Company
        to whom shipments are made.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        3. Authorized Users
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        a. You agree that the Platform will be accessed and used only by you.
        For that purpose, you will designate authorized users whom you authorize
        to access and use the Platform (“Authorized User”). The Platform may
        only be accessed and used in connection with Equipment and/or Hardware
        necessary to access the Platform and you must pay any necessary access
        fees. Carrier or its Affiliates will not be liable for any costs,
        damages or losses resulting from unauthorized access (including hacking)
        to or into, or unauthorized or erroneous use of your user accounts.
        However, you may be liable to Carrier or other parties due to any
        unauthorized access (including hacking) to or into, or unauthorized or
        erroneous use of another user account.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        b. You are responsible for the acquisition, configuration, monitoring,
        maintenance and management of your software and hardware related to your
        use of the Platform, including LAN, computers, modems,
        telecommunications devices, and your network connection to the Platform.
        We are not responsible for the network connection or for issues,
        problems or conditions arising from or related to the network
        connection, including but not limited to bandwidth issues, network
        outages, and/or other conditions that are caused by the Web and/or
        network connection.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        4. Disclaimer of Warranties.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        YOUR USE OF THE PLATFORM IS AT YOUR SOLE RISK AND YOU ACKNOWLEDGE AND
        AGREE THAT YOU ASSUME FULL RESPONSIBILITY FOR SUCH USE. NO ADVICE OR
        INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM CARRIER OR
        THROUGH OR FROM THE PLATFORM SHALL CREATE ANY WARRANTY OF ANY KIND. THE
        PLATFORM IS PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS
        AVAILABLE&quot; BASIS. CARRIER EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY
        KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO (i.) THE
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE; (ii.) ANY WARRANTIES IMPLIED FROM A COURSE OF PERFORMANCE OR
        DEALING; (iii.) ANY REPRESENTATIONS OR WARRANTIES AS TO THE
        COMPLETENESS, ACCURACY, ADEQUACY, USEFULNESS, TIMELINESS OR RELIABILITY
        OF THE MATERIALS AVAILABLE ON THE PLATFORM; (iv.) ANY REPRESENTATIONS OR
        WARRANTIES THAT THE MATERIALS AVAILABLE ON THE PLATFORM ARE NOT
        SUSCEPTIBLE TO LOSS OR CORRUPTION; (v.) ANY REPRESENTATIONS OR
        WARRANTIES THAT ANY MATERIALS AVAILABLE ON THE PLATFORM ARE
        NON-INFRINGING; (vi.) ANY REPRESENTATIONS OR WARRANTIES THAT ACCESS TO
        OR AVAILABILITY OF THE PLATFORM WILL BE CONTINUOUS, UNINTERRUPTED OR
        ERROR-FREE; (vi.) ANY REPRESENTATIONS OR WARRANTIES THAT THE PLATFORM
        WILL BE ERROR-FREE, VIRUS-FREE, SECURE, OR NOT SUSCEPTIBLE TO HACKING OR
        OTHER UNAUTHORIZED ACCESS OR USE; OR. (viii.) ANY REPRESENTATIONS OR
        WARRANTIES THAT TELEMATICS COMPONENTS, SERVICES OR SYSTEMS NOT PROVIDED
        BY CARRIER OR ITS AFFILIATES ARE COMPATIBLE WITH THE PLATFORM. IN
        CERTAIN JURISDICTIONS, THE LAW MAY NOT PERMIT THE DISCLAIMER OF
        WARRANTIES, SO SOME OR ALL OF THE ABOVE DISCLAIMER MAY NOT APPLY TO YOU.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        5. Limitation of Liability. NOTWITHSTANDING ANYTHING ELSE IN THE TERMS,
        AND TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEITHER CARRIER
        NOR ITS AFFILIATES, SUPPLIERS, OR SERVICE PROVIDERS WILL BE LIABLE FOR
        ANY INDIRECT, INCIDENTAL, COLLATERAL, SPECIAL, PUNITIVE OR CONSEQUENTIAL
        DAMAGES OR LOSSES, SUCH AS BUT NOT LIMITED TO, LOSS OF REVENUES, LOSS OF
        ANTICIPATED SAVINGS OR LOST PROFITS, RECALLS, HARM TO BUSINESS OR
        BUSINESS REPUTATION ARISING OUT OF OR IN ANY WAY RELATED TO THE USE,
        ACCESS TO, MISUSE, OR INABILITY TO USE THE PLATFORM. EVEN IF CARRIER HAS
        BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES (INCLUDING DAMAGES
        INCURRED BY THIRD PARTIES). THE EXCLUSION OF DAMAGES UNDER THIS SECTION
        5 IS INDEPENDENT OF ANY REMEDY PROVIDED UNDER THE TERMS AND SURVIVES IN
        THE EVENT SUCH REMEDY FAILS OF ITS ESSENTIAL PURPOSE OR IS OTHERWISE
        DEEMED UNENFORCEABLE. THESE LIMITATIONS AND EXCLUSIONS APPLY WITHOUT
        REGARD TO WHETHER DAMAGES ARISE FROM BREACH OF
        <br />
        Last Update 04/01/2021 ©2021 Carrier. All Rights Reserved.
        <br />
        CONTRACT OR WARRANTY, NEGLIGENCE OR ANY OTHER CAUSE OF ACTION. TO THE
        EXTENT THAT APPLICABLE LAW DOES NOT PROHIBIT SUCH EXCLUSIONS AND
        LIMITATIONS.
        <br />
        THE PRECEDING LIMITATIONS OF LIABILITY DO NOT APPLY TO LIABILITIES THAT
        CANNOT BE EXCLUDED OR LIMITED BY APPLICABLE LAWS, SUCH AS IN THE EVENT
        OF STATUTORILY MANDATED LIABILITY (INCLUDING LIABILITY UNDER APPLICABLE
        PRODUCT LIABILITY LAW) OR IN THE EVENT OF PERSONAL INJURY ARISING SOLELY
        FROM CARRIER’S GROSS NEGLIGENCE OR WILLFUL MISCONDUCT.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        6. Company Indemnification. UPON OUR REQUEST YOU AGREE TO INDEMNIFY,
        DEFEND AND HOLD HARMLESS CARRIER FROM AND AGAINST ANY AND ALL CLAIMS,
        LAWSUITS, DEMANDS, ACTIONS OR OTHER PROCEEDINGS BROUGHT AGAINST IT BY
        ANY THIRD PARTY DUE TO, ARISING OUT OF OR RELATED TO YOUR (A) USE OF THE
        PLATFORM, (B) VIOLATION OF THE TERMS, OR (C) YOUR VIOLATION OF ANY LAW,
        REGULATION OR THIRD PARTY RIGHTS. You shall pay any and all costs,
        damages and expenses, including, without limitation, reasonable
        attorneys’ fees and costs awarded against or otherwise incurred by
        Carrier in connection with or arising from any such claim, lawsuit,
        action, demand or other proceeding. Carrier may, at its own expense,
        assume the exclusive defense and control of any matter otherwise subject
        to indemnification by you, in which event you agree to cooperate with
        Carrier in asserting any available defenses.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        7. Suspension, Discontinuation or Cancellation.
        <br />
        a. With Cause. Carrier reserve the right to immediately suspend or
        terminate your access to the Platform, with or without notice, if in
        Carrier’s sole judgment, you breach the Terms, engage in any harmful,
        unlawful, deceitful or fraudulent conduct in any way relating to the
        Terms or the Platform.
        <br />
        b. Without Cause. Carrier reserve the right to suspend or terminate your
        access to the Platform, with or without notice for any reason at any
        time.
        <br />
        c. Effects of Suspension, Discontinuation or Termination by Carrier.
        CARRIER SHALL HAVE NO LIABILITY WHATSOEVER AS A RESULT OF EXERCISING A
        RIGHT TO SUSPEND OR TERMINATE YOUR ACCESS TO THE PLATFORM. All
        provisions of the Terms which by their nature survive termination or
        expiration, shall survive termination of your use of or access to the
        Platform. In no event shall Carrier or its Affiliates be obligated to
        take or buy back any Equipment and/or Hardware made unnecessary or
        unusable as a result of exercising a right to suspend or terminate use
        of or access to the Platform.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        8. Modifications by Carrier.
        <br />
        a. Modification of the Terms. Carrier may modify the Terms with or
        without notice, at any time, and from time to time, by posting a new
        version of the Terms on the Platform. In some instances, if the changes
        are material, Carrier may notify you about such changes and any choices
        you may have or actions you can take before they go into effect. If you
        do not agree with any modification, do not continue to use the Platform.
        Your continued access or use of the Platform after our notice indicates
        acceptance to the modified Terms. The modified Terms shall be effective
        as of the date they are posted on the Platform. b. Platform
        Modifications. At any time, and from time-to-time, Carrier reserves the
        right, in its sole judgement, to make all such modifications, changes,
        updates, supplements and additions to the Platform, or to discontinue
        the entire Platform, or any features thereof. In the event of such
        modifications or discontinuation, Carrier shall have no obligation to
        continue to provide support or maintenance for the prior version of the
        Platform. In addition, Company may be required, at their sole expense,
        to purchase or use new or additional Equipment and/or Hardware in order
        to continue to utilize the Platform as modified.
        <br />
        c. In no event shall Carrier be obligated to take back or buy back any
        Equipment and/or Hardware in the event of a modification to the Terms or
        the Platform.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        9. Export Controls. Company acknowledges that the Platform (and any
        related Data) provided hereunder are subject to the laws and regulations
        of the United States that govern exports and other international trade
        controls that may restrict transfers of such items to other countries
        and parties. Company shall not export, reexport, supply or release such
        items contrary to the laws and regulations of the United States and
        other countries relating to export trade, or to any country, entity or
        other party which is ineligible to receive such items under U.S. laws
        and regulations, including regulations of the U.S. Department of
        Commerce or the U.S. Department of the Treasury. Company’s failure to
        abide by the obligations of this section will be deemed a material
        breach of the Terms permitting Carrier to terminate Company’s use of and
        access to the Platform immediately, without notice, without further
        obligation and without prejudice to any other remedies that may be
        available to it. Company shall indemnify, defend and hold Carrier and
        its Affiliates harmless for all costs incurred in connection with
        Company’s failure to abide by the obligations of this section.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        10. Compliance with Laws. By accepting the Terms, Company agree to
        comply with all applicable laws, regulations, rules and guidelines,
        including but not limited to those dealing with bribery and the export,
        re-export, or transfer of goods, software and technology, or any other
        future technology and/or telecommunications standards available as part
        of the Platform. Company’s failure to abide by the obligations of this
        section will be deemed a material breach of the Terms permitting Carrier
        to terminate Company’s use of and access to the Platform immediately,
        without notice, without further obligation and without prejudice to any
        other remedies that may be available to it. Company shall indemnify,
        defend and hold Carrier and its Affiliates harmless for all costs
        incurred in connection with Subscriber’s failure to abide by the
        obligations of this section.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        11. Choice of Law & Jurisdiction. The Terms and any sales, service or
        other transactions arising hereunder or related hereto shall be governed
        by, and construed in accordance with, the laws of the State of New York
        (excluding its conflicts of law provisions), and Company irrevocably
        waives the right to trial by jury and consents to the jurisdiction of
        the courts located in the State of New York for any action arising out
        of or relating to the Terms. The provisions of the U.N. Convention on
        Contracts for the International Sales of Goods shall not be applicable.
        A determination that any provision of the Terms is ineffective or
        unenforceable shall not impair the enforceability of other provisions
        contained herein.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        12. Force Majeure. Carrier shall not be responsible for any losses,
        damages, or penalties occasioned by any delay or failure in the
        provision of all or any portion of the Platform (a) that are caused by
        acts of nature, or forces or causes beyond Carrier reasonable control,
        including but not limited to supplier and service provider delays,
        strikes, lock-outs, industrial disputes, fire, flood, acts of God, war,
        insurrection, vandalism, sabotage, invasion, riot, national emergency,
        piracy, hijack, acts of terrorism, embargoes or restraints, extreme
        weather or traffic conditions, epidemic, legislation, regulation, order
        or other act of any government or governmental agency. In case of such
        delay, performance shall be resumed when delays have ceased to exist.
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        13. General Provisions. The Terms and/or any other valid agreement
        between you and Carrier for access to and use of the Platform,
        constitute the entire agreement between you and Carrier and govern your
        access to and use of the Platform, superseding any and all prior
        agreements, negotiations and communications (whether written, oral or
        electronic) between you and Carrier with respect to the subject matter
        hereof. No change, modification, or wavier of the Terms, will be binding
        on Carrier unless made in writing, with Carrier’s approval. Any rights
        not otherwise expressly granted under the Terms are reserved by Carrier
        and its licensors. The failure of Carrier to exercise or enforce any
        right or provision of the Terms shall not constitute a waiver of such
        right or provision. If any part of the Terms is held invalid or
        unenforceable, by a court of competent jurisdiction, that portion shall
        be construed in a manner consistent with applicable law to reflect, as
        nearly as possible, the original intentions of Carrier, and the
        remaining portions shall remain in full force and effect. You agree that
        regardless of any statute or law to the contrary, any claim or cause of
        action arising out of or related to use of the Platform must be filed
        within one (1) year after such claim or cause of action arose or be
        forever barred.
      </Typography>
    </div>
  );
};
